module.exports = __webpack_public_path__ + "static/media/cloud-solaire.fec31563.jpg";